import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { NotificationItem, propsNotificationsState } from './interfaces';

const initialState: propsNotificationsState = {
  items: [],
  loading: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    notificationsRequest: (state) => {
      state.loading = true;
    },
    notificationsSuccess: (state, action: PayloadAction<NotificationItem[]>) => {
      state.items = action.payload;
      state.loading = false;
    },
    notificationsMarkRead: (state, action: PayloadAction<string>) => {
      const item = state.items.find((i) => i.id === action.payload);
      if (item) item.read = true;
    },
    notificationsMarkAllRead: (state) => {
      state.items.forEach((i) => {
        i.read = true;
      });
    },
    clearNotifications: () => initialState,
  },
});

export const {
  notificationsRequest,
  notificationsSuccess,
  notificationsMarkRead,
  notificationsMarkAllRead,
  clearNotifications,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
